export function getScreenIdFromElement(element) {
    var elementId = element.attr("id"),
        screenId,
        elementRealId;

    if (elementId) {
        var index = elementId.indexOf("_");

        screenId = elementId.substr(0, index);
        elementRealId = elementId.substr(index + 1);
    }

    return {
        screenId: screenId,
        elementId: elementRealId
    };
}
